import { SelectProps } from 'antd'
import { Select } from 'components/atoms'
import { transformData, useProfile } from 'hooks'
import { useEffect, useState } from 'react'

interface IProps extends SelectProps<any, any> {
  title?: string
  required?: boolean
  className?: string
  preventInput?: boolean
  defaultValue?: number
}

const SelectMajor = (props: IProps) => {
  const { title, onChange, defaultValue, ...resProps } = props
  const { transformArrayObject } = transformData()
  const { profile } = useProfile()
  const [options, setOptions] = useState<any>([])
  const [option, setOption] = useState<any>(null)

  useEffect(() => {
    const options = transformArrayObject(profile?.clinic_majors || [], {
      value: 'id',
      label: 'name'
    })
    setOptions(options)
    if (defaultValue) {
      const op = options?.find((item) => item.value === defaultValue)
      setOption(op)
    }
  }, [profile?.clinic_majors, defaultValue])

  const handleOnChange = (data: any, op: any) => {
    setOption(op)
    if (onChange) onChange(data, op)
  }

  return (
    <Select
      showArrow
      allowClear
      title={title}
      placeholder="please-choose-info"
      options={options}
      filterOption={false}
      onChange={handleOnChange}
      value={option}
      {...resProps}
    />
  )
}

export default SelectMajor
